'use client'

import { Button, Container, Dialog, Image, Spacer, Text } from '@vinted/web-ui'

import { useIsDarkMode } from '@marketplace-web/dark-mode/dark-mode-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { CDN_IMAGES_URL } from '@marketplace-web/shared/assets'

type Props = { handleClose: () => void } & React.ComponentProps<typeof Dialog>

const FormSuccessModal = ({ closeOnOverlay = true, handleClose, ...props }: Props) => {
  const isDarkMode = useIsDarkMode()
  const translate = useTranslate('advertising.form.success_message')

  const iconPath = `${CDN_IMAGES_URL}/landing/advertising/check-circle${
    isDarkMode ? '_dark' : ''
  }.svg`

  return (
    <Dialog
      testId="advertising-form-success-modal"
      closeOnOverlay={closeOnOverlay}
      defaultCallback={handleClose}
      {...props}
    >
      <Container>
        <div className="u-flexbox u-align-items-center u-flex-direction-column">
          <Image
            src={iconPath}
            size={Image.Size.Large}
            alt=""
            testId="advertising-form-success-modal-image"
          />
          <Spacer size={Spacer.Size.Large} />
          <Text
            as="h1"
            text={translate('title')}
            type={Text.Type.Heading}
            alignment={Text.Alignment.Center}
          />
        </div>
        <Spacer size={Spacer.Size.Large} />
        <Text as="span" text={translate('subtitle')} alignment={Text.Alignment.Center} />
        <Spacer size={Spacer.Size.X2Large} />
        <Button
          theme="primary"
          styling={Button.Styling.Filled}
          text={translate('close')}
          onClick={handleClose}
        />
      </Container>
    </Dialog>
  )
}

export default FormSuccessModal
